import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { BaseDisplayModel } from '@common/models/baseDisplayModel';

export class ServiceRequestItemsHoldModalModel extends BaseDisplayModel {
    public serviceRequestItemIds: any[] = null;
    public cargoHoldTypeId = null;
    public cargoHoldRemark = null;

    constructor() {
        super();
    }

    generateGroup() {
        const form = new UntypedFormGroup({
            cargoHoldTypeId: new UntypedFormControl({ value: null, disabled: false }),
            cargoHoldRemark: new UntypedFormControl({ value: null, disabled: false })
        });

        form.patchValue(this);
        return form;
    }
}
